import React from 'react';
import { connect, useDispatch } from "react-redux";
import PropTypes from 'prop-types';

import Input from './Input';

import { addToast } from "../../../actions/index";

function ConnectedNewPlaylist({ cancelClick, modalHasEntered, extraAction, storePlaylists }) {

  const dispatch = useDispatch();
  const createPlaylist = name => {
    if (storePlaylists.new) {
      storePlaylists.new(name, [], {}, null, extraAction);
      if (!extraAction) {
        dispatch(addToast({ content: <span>Playlist '{name}' created.</span>, typeClass: 'success', iconStyle: { padding: 16, marginRight: 16 } }))
      }      
    } 
  }

  return (
    <Input label={`Name`} placeholder={`Playlist name`}
      labelValid={`Create`} validClick={createPlaylist} cancelClick={cancelClick}
      modalHasEntered={modalHasEntered} value={``} />
  )
}

ConnectedNewPlaylist.propTypes = {
  cancelClick: PropTypes.func,
  modalHasEntered: PropTypes.bool,
  extraAction: PropTypes.func
}

const NewPlaylist = connect(
  state => ({
    storePlaylists: state.storePlaylists
  })
)(ConnectedNewPlaylist);

export default NewPlaylist;
